import { useState    } from "react";
import { GoogleMap, LoadScript, Marker,MarkerClusterer  } from "@react-google-maps/api";
    
export default function GoogleMapComponent({ googleMapApiKey, addresses, containerStyle }) {
  const [locations, setLocations] = useState([]);

  // Geocode addresses or use coordinates directly
  const geocodeAddresses = async () => {
    if (!addresses || addresses.length === 0) return;
    const geocoder = new window.google.maps.Geocoder();
    const results = [];

    for (let item of addresses) {
      try {
        if (typeof item === "string") {
          const response = await geocoder.geocode({ address: item });
          const geoResults = response.results;
          if (geoResults?.length > 0) {
            results.push(geoResults[0].geometry.location);
          }
        } else if (item?.lat && item?.lng) {
          results.push(new window.google.maps.LatLng(item.lat, item.lng));
        }
      } catch (err) {
        console.error("Geocode failed for:", item, err);
      }
    }

    setLocations(results);
  };

  // Calculate map center
  const getCenter = (locations) => {
    if (!locations || locations.length === 0)
      return { lat: 37.0902, lng: -95.7129 }; // default USA

    const latSum = locations.reduce((sum, loc) => sum + loc.lat(), 0);
    const lngSum = locations.reduce((sum, loc) => sum + loc.lng(), 0);

    return {
      lat: latSum / locations.length,
      lng: lngSum / locations.length,
    };
  };

  return (
    <LoadScript googleMapsApiKey={googleMapApiKey}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={getCenter(locations)}
        zoom={addresses?.length === 1 ? 14 : 2}
        onLoad={() => {
          if (addresses?.length > 0) geocodeAddresses();
        }}
      >
        {/* Marker clustering */}
        {locations.length > 0 && (
          <MarkerClusterer>
            {(clusterer) =>
              locations.map((loc, i) => (
                <Marker
                  key={i}
                  position={{ lat: loc.lat(), lng: loc.lng() }}
                  clusterer={clusterer}
                />
              ))
            }
          </MarkerClusterer>
        )}
      </GoogleMap>
    </LoadScript>
  );
}
